// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3473": "cc576b18","718": "5f1609e0","7869": "22f405b2",}[chunkId] + ".css"
}